import React, { useEffect, useState } from "react";
import StatusDataContext from "../context/StatusDataContext";
import useProductAttributeCodes from '../hooks/useProductAttributeCodes';
import useStatusDefinitionList from '../hooks/useStatusDefinitionList';
import useStatusGlossary from '../hooks/useStatusGlossary';
const StatusDataProvider = ({ children }) => {
    const { productAttributeCodes, loading: codesLoading, error: codeError } = useProductAttributeCodes();
    const { statusDefinitionList, loading: definitionsLoading, error: definitionsError } = useStatusDefinitionList();
    const { glossary, loading: glossaryLoading, error: glossaryError } = useStatusGlossary();
    const [legacyPref, setLegacyPref] = useState(false);
    useEffect(() => {
        const storedVal = sessionStorage.getItem('coverageDetailsPref') === 'legacy';
        setLegacyPref(storedVal);
    }, []);
    return (<StatusDataContext.Provider value={{
            statusDataLoading: codesLoading || definitionsLoading || glossaryLoading,
            codesLoading,
            definitionsLoading,
            glossaryLoading,
            productAttributeCodes,
            statusDefinitionList,
            glossary,
            legacyPref,
            setLegacyPref,
        }}>
      {children}
    </StatusDataContext.Provider>);
};
export default StatusDataProvider;
